// @flow
import React from 'react';
import { List } from 'semantic-ui-react';

export const BulletedList = ({ items }) => (
  <List bulleted={true}>
    {items.map((item, index) => (
      <List.Item key={index}>{item}</List.Item>
    ))}
  </List>
);
